<template>
   <div class="footer">
      <div class="layui-container">
        <p class="footer-web"></p>
        <div class="layui-row footer-contact">
          <div class="layui-col-sm2 layui-col-lg1"><img src="@/assets/images/erweima.jpg" width="80px"></div>
          <div class="layui-col-sm10 layui-col-lg11">
            <div class="layui-row">
              <div class="layui-col-sm4 layui-col-md6 layui-col-lg6">
                <p>&nbsp;</p>
                <!-- <p class="contact-top"><i
                    class="layui-icon layui-icon-cellphone"></i>&nbsp;19531251450&nbsp;&nbsp;(9:00-18:00)</p>
                <p class="contact-bottom"><i class="layui-icon layui-icon-home"></i>&nbsp;2712608450@qq.com</span></p> -->
              </div>
              <div class="layui-col-sm6 layui-col-md4 layui-col-lg6">
                <p class="contact-bottom"><span class="right">Copyright ©2023 www.goubudian.com All Rights Reserved.<br />
                    备案号：苏ICP备2022032336号-1</span></p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>
<script>
export default {
  name: 'common-header',
  data() {
    return {
      userInfo: {
        avatar: 'https://static.goubudian.com/Uploads/lottery/2305/647315c3c7b87.png',
        username: ''
      }
    }
  },
  components: {

  },
  methods: {

  }
}
</script>
<style scoped lang="scss">
@import url(../assets/css/index.css);
.footer{
  margin-top: 80px;
}
</style>



// WEBPACK FOOTER //
// src/components/footer.vue